import { gql } from '@apollo/client'

export const BountyFragment = gql`
  fragment Bounty on Bounty {
    nftType
    bountyID
    initBountyNumber
    remainingBountyNumber
    unitPrice
    currencyType: currency
    creatorWalletAddress: bountyCreator
    isCancelled
    fulfilledAt
    cancelledAt
    bountyRequired {
      ... on ApostleBountyRequired {
        apostleType
        classID
        mainSkillID
        mainSkillFullID
        otherSkillID1
        otherSkillFullID1
        otherSkillID2
        otherSkillFullID2
        minMainSkillLevel
        minOtherSkill1Level
        minOtherSkill2Level
        minIV
        reforgeCount
      }
    }
  }
`
